export default {
  class:     'className',
  for:       'htmlFor',
  maxlength: 'maxLength',

  colspan: 'colSpan',
  rowspan: 'rowSpan',
}
